import { updateURLQueryParam } from '../../../../../utils/url';
import { deriveStatus } from './status';

/**
 * filterCampaignsByStatus filters campaigns by either
 * a) The status selected via the select dropdown
 * b) The status query parameter in the URL
 * c) All campaigns
 */
export const filterCampaignsByStatus = (campaigns: Array<any>, statusFilter: string): Array<any> => {
  if (statusFilter === 'All') {
    // Reset status filter
    updateURLQueryParam('status', '');
    return campaigns;
  }

  updateURLQueryParam('status', statusFilter);

  return (campaigns || []).filter(
    campaign => deriveStatus(campaign.startDate, campaign.endDate, campaign.status) === statusFilter,
  );
};

export const filterCampaignsByName = (campaigns: Array<any>, nameFilter: string): Array<any> => {
  updateURLQueryParam('name', nameFilter);

  return (campaigns || []).filter(campaign => campaign.name.toLowerCase().includes(nameFilter.toLowerCase()));
};
